<template>
  <div class="main-AboutUs backdrop" id="main-AboutUs">
    <div class="introduce">
      <ul>
        <li v-for="obj in $t('img')">
          <img :src="obj.src">
          <div>{{obj.name}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "us_environment",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  .main-AboutUs{
    padding: 0;
  }
  #paging{
    margin: auto;
    width: 50%;
    border: 1px solid #f8f8f8;
  }
  ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  ul li {
    width: 4rem;
    flex-grow: 1;
    margin: .1rem;
    text-align: center;
    position: relative;
    cursor: pointer;
  }
  .main-AboutUs .introduce img {
    width: 100%;
    height: 100%;
  }
  ul li>div{
    position: absolute;
    bottom: 0;
    background-color: rgba(0,0,0,.3);
    width: 100%;
    line-height: .8rem;
    font-weight: 600;
    font-size: .2rem;
    color: #fff;
  }


    /*关于我们开始*/
  .main-AboutUs {
    background-image: url(../assets/img/pic/pic_ABOUT.jpg);
    background-repeat: no-repeat;
  }

  .main-AboutUs .introduce {
    display: flex;
    flex-wrap: wrap;
    margin: 0.3rem 0.7rem 0 0.7rem;
    /*animation: 2s aircraft;*/
  }

  .main-AboutUs .introduce > div {
    width: 385px;
    flex-grow: 1;
    align-self: center;
  }

  .main-AboutUs .introduce > div:first-of-type {
    text-align: center;
  }

  .main-AboutUs .introduce span {
    font-family: 微软雅黑;
    font-size: 14px;
    line-height: 200%;
    color: #5a5a5a;
  }

  /*关于我们结束*/

  /*新闻动态结束*/
  @media screen and (max-width: 1024px) {

    .msg div {
      width: 14rem;
      margin: auto;
    }

    .title_content {
      font-size: 1rem;

    }

    .title_msg {
      font-size: .3rem;
    }
  }

  @media screen and (max-width: 768px) {

    .title_content span {
      font-size: 12px;
    }

    .msg div {
      width: 100%;
    }

    .title_msg {
      width: 70%;
    }
    ul li {
       /*width: 5rem;*/
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/us_environment.vue